import React from "react";

/** Props for {@link ClassAccessSimulationCard}. */
interface ClassAccessSimulationCardProps {
  /** Simulation id used for navigation to the public detail page. */
  simId: number;
  /** Simulation name. */
  label: string;
  /** Opens the public Self-Serve simulation detail for this sim in a new tab. */
  onView: (simId: number) => void;
}

/**
 * One assigned simulation on Access Simulation. "View Simulation" opens the
 * public detail page in a new tab (`/class/:slug/simulation/:simId`, ELS-671).
 */
const ClassAccessSimulationCard: React.FC<ClassAccessSimulationCardProps> = ({
  simId,
  label,
  onView,
}) => {
  return (
    <article className="ss-sim-card" role="listitem">
      <h2 className="ss-sim-card-title">{label}</h2>
      <button
        type="button"
        className="edsimsV2-pill-button edsimsV2-pill-button--primary ss-sim-card-play"
        aria-label={`View ${label}, opens in a new tab`}
        onClick={() => onView(simId)}
      >
        View Simulation
      </button>
    </article>
  );
};

export default ClassAccessSimulationCard;
